import { Popover, Row } from 'antd';
import React from 'react';
import { useQuery } from 'react-query';
import { isNil } from 'lodash';
import Title from './Title';
import { getPropStatusHistory } from 'services/proposal';
import { getConStatusHistory } from 'services/fincontract';
import { getTPStatusByTpid } from 'services/thirdParty';
import { getAssetStatusHistory } from 'services/assets';
import { GetColStatusHistory } from 'services/collection';
import { DataGridColDef } from './DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';
import moment from 'moment';

type StatusHistoryPopoverProps = {
  objectid: number;
  entity: string;
};

const StatusHistoryPopover: React.FC<StatusHistoryPopoverProps> = ({
  objectid,
  entity,
  ...props
}) => {
  const { children } = props;

  const { data } = useStatus(objectid, entity);
  const columns: DataGridColDef<any>[] = [
   
    {
      dataIndex: entity === 'COLLECTION' 
        ? 'collevellabel' 
        : entity === 'THIRDPARTY' 
        ? 'statustypelabel' 
        : 'phaselabel',
    },
    {
      dataIndex: entity === 'COLLECTION' ? 'colstatuslabel' : 'statuslabel',
      width: 200,
    },
    {
      dataIndex: entity === 'COLLECTION' ? 'colstatusdate' : 'statusdate',
      render: (val) => moment(val).format('YYYY-MM-DD'),
    },
    {
      dataIndex: 'username',
    },
  ];
  const content = (
    <div style={{ marginTop: '-20px', width: '580px', marginLeft: '0px',marginRight: '-20px' }}>
      <DataGrid
        columns={columns}
        dataSource={data ?? []}
        pagination={false}
        scroll={{ y: 100 }}
      />
    </div>
  );

  return (
    <Popover
      style={{ padding: '0px' }}
      className="Popup"
      content={content}
      title={
        <Row justify="center">
          <Title level={5} comcode="statushistory" />
        </Row>
      }
      overlayInnerStyle={{ width: '600px', height: '200px' }}
    >
      {children}
    </Popover>
  );
};
const useStatus = (Objectid: number, entity: string) => {
  const QueryProp = useQuery(
    ['getPropStatusHistory', Objectid],
    () =>
      getPropStatusHistory({ ctrid: Objectid }).then((res) => res.list || []),
    {
      enabled: entity === 'PROPOSAL' && !isNil(Objectid),
      staleTime: 60 * 1000 * 3,
    }
  );

  const QueryCon = useQuery(
    ['getConStatusHistory', Objectid],
    () =>
      getConStatusHistory({ ctrid: Objectid }).then((res) => res.list || []),
    {
      enabled: entity === 'PROD' && !isNil(Objectid),
      staleTime: 60 * 1000 * 3,
    }
  );

  const QueryTP = useQuery(
    ['getTPStatusByTpid', Objectid],
    () =>
      getTPStatusByTpid({
        tpid: Objectid,
        type: 'STATUS',
      }).then((res) => res.list || []),
    {
      enabled: entity === 'THIRDPARTY' && !isNil(Objectid),
      staleTime: 60 * 1000 * 3,
    }
  );
  const QueryAsset = useQuery(
    ['getAssetStatusHistory', Objectid],
    () =>
      getAssetStatusHistory({ assetid: Objectid }).then(
        (res) => res.list || []
      ),
    {
      enabled: entity === 'ASSET' && !isNil(Objectid),
      staleTime: 60 * 1000 * 3,
    }
  );
  const QueryColl = useQuery(
    ['GetColStatusHistory', Objectid],
    () =>
      GetColStatusHistory({ colid: Number(Objectid) }).then(
        (res) => res.list || []
      ),
    {
      enabled: entity === 'COLLECTION' && !isNil(Objectid),
      staleTime: 60 * 1000 * 3,
    }
  );

  switch (entity) {
    case 'PROPOSAL':
      return QueryProp;
    case 'PROD':
      return QueryCon;
    case 'THIRDPARTY':
      return QueryTP;
    case 'ASSET':
      return QueryAsset;
    case 'COLLECTION':
      return QueryColl;
    default:
      return {} as any;
  }
};

export default StatusHistoryPopover;
